import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FCC } from "types";

import { ListBoxMultiple } from "@/components/Interface/FormFields/ListBoxMultiple/ListBoxMultiple";
import { FilterDialogForm } from "@/components/Portal/components/PortalDeviceListFilter/types";
import { GetSimListSimTypeItem } from "@/services/model";

interface Props {
  control: Control<FilterDialogForm, any>;
}

/** Both SIM types use the shared product names. */
const simTypeLabelKey = {
  TRIPLESIM: "translation:Common.products.simCard",
  ESIM: "translation:Common.products.esim",
} as const satisfies Record<GetSimListSimTypeItem, string>;

export const SimTypeFilter: FCC<Props> = ({ control }) => {
  const { t } = useTranslation(["portal", "translation"]);

  return (
    <div>
      <Controller<FilterDialogForm>
        control={control}
        name="simType"
        render={({ field: { onChange, value } }) => (
          <ListBoxMultiple<GetSimListSimTypeItem>
            className="full-width"
            inverted
            showSelectedAsTags
            selected={
              (typeof value === "string"
                ? [value]
                : value) as GetSimListSimTypeItem[]
            }
            setSelected={onChange}
            displayValue={(value) => t(simTypeLabelKey[value])}
            availableValues={["TRIPLESIM", "ESIM"]}
            placeholder={t("cockpit.filter.dropdowns.simType.placeholder")}
            itemLabel={t("cockpit.filter.dropdowns.simType.placeholder")}
          />
        )}
      />
    </div>
  );
};
